module.exports = {
  mapLocale: {
    "ja-JP": "jp/ja", // maps locale to URL prefix
    "en-US": "in/en",
    "ar": "mena/ar", // Arabic locale mapping
    "en-AE": "mena/en",
    "en-GB": "uk/en",
  },
  cookieLang: {
    "ja-JP": "jp/ja", // used for language cookie (e.g., to remember user's language)
    "en-US": "in/en",
    "ar": "mena/ar",
    "en-AE": "mena/en",
    "en-GB": "uk/en",
  },
  siteUrl: {
    "ja-JP": "jp/ja", // used for full URL generation or routing
    "en-US": "in/en",
    "ar": "mena/ar",
    "en-AE": "mena/en",
    "en-GB": "uk/en",
  },
  mapLangSelector: {
    "ja-JP": "日本語",
    "en-US": "English (India)",
    "ar": "العربية",
    "en-AE": "English (MENA)",
    "en-GB": "English (UK)",
  },
  mapAddressCountry: {
    "ja-JP": "Japan", // used if you display country-specific content/address info
    "en-US": "United States of America",
    "ar": "United Arab Emirates", // Arabic country mapping
    "en-AE": "United Arab Emirates",
    "en-GB": "United Kingdom",
  },
}